"use client";
import type { ContainerProps as _ContainerProps } from "@chakra-ui/react";
import { Container as _Container, forwardRef } from "@chakra-ui/react";

export interface ContainerProps extends _ContainerProps {}

export const Container = forwardRef<ContainerProps, "div">(({ ...props }, ref) => (
    <_Container ref={ref} {...props} />
));
